/* Sydney Fireplace Studio theme JS. Vanilla, event delegation only. */
(function () {
  'use strict';
  if (window.__sfsTheme) return;
  window.__sfsTheme = true;
  var KEY = 'sfs-cart-items';
  var SHOPIFY = !!window.SFS_SHOPIFY;

  function getItems() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
  }
  function setItems(items) { localStorage.setItem(KEY, JSON.stringify(items)); renderCart(); }
  function parsePrice(text) { return parseInt(String(text).replace(/[^0-9]/g, ''), 10) || 0; }
  function fmt(n) { return '$' + n.toLocaleString('en-AU'); }

  function addItem(name, price, img, qty) {
    var items = getItems();
    for (var i = 0; i < items.length; i++) {
      if (items[i].name === name) { items[i].qty += qty; setItems(items); return; }
    }
    items.push({ name: name, price: price, img: img, qty: qty });
    setItems(items);
  }
  function changeQty(name, delta) {
    var items = getItems();
    for (var i = 0; i < items.length; i++) {
      if (items[i].name === name) {
        items[i].qty += delta;
        if (items[i].qty < 1) items.splice(i, 1);
        break;
      }
    }
    setItems(items);
  }
  function removeItem(name) {
    setItems(getItems().filter(function (it) { return it.name !== name; }));
  }

  function renderCart() {
    if (SHOPIFY) return;
    var items = getItems();
    var count = 0, subtotal = 0;
    items.forEach(function (it) { count += it.qty; subtotal += it.qty * it.price; });

    var badges = document.querySelectorAll('[data-cart-count]');
    for (var i = 0; i < badges.length; i++) badges[i].textContent = String(count);

    var list = document.querySelector('[data-cart-items]');
    if (!list) return;
    var empty = document.querySelector('[data-cart-empty]');
    var foot = document.querySelector('[data-cart-foot]');
    var sub = document.querySelector('[data-cart-subtotal]');
    if (sub) sub.textContent = fmt(subtotal);
    if (empty) empty.style.display = items.length ? 'none' : 'block';
    if (foot) foot.style.display = items.length ? '' : 'none';

    var html = '';
    items.forEach(function (it) {
      html += '<div class="sfs-cartdrawer__item">' +
        '<div class="sfs-cartdrawer__thumb"><img src="' + it.img + '" alt=""></div>' +
        '<div class="sfs-cartdrawer__info">' +
          '<p class="sfs-cartdrawer__name">' + it.name + '</p>' +
          '<p class="sfs-cartdrawer__each">' + fmt(it.price) + ' each</p>' +
          '<div class="sfs-cartdrawer__qtyrow">' +
            '<span class="sfs-cartdrawer__qty">' +
              '<button type="button" data-cart-qty="dec" data-name="' + it.name + '" aria-label="Decrease">&minus;</button>' +
              '<span>' + it.qty + '</span>' +
              '<button type="button" data-cart-qty="inc" data-name="' + it.name + '" aria-label="Increase">+</button>' +
            '</span>' +
            '<button type="button" class="sfs-cartdrawer__remove" data-cart-remove data-name="' + it.name + '">Remove</button>' +
          '</div>' +
        '</div>' +
        '<p class="sfs-cartdrawer__line">' + fmt(it.price * it.qty) + '</p>' +
      '</div>';
    });
    list.innerHTML = html;
  }

  /* ---- Shopify AJAX cart (live store only). Keeps everything in the drawer. ---- */
  function money(cents) { return fmt(Math.round(cents / 100)); }

  function paintShopifyCart(cart) {
    var badges = document.querySelectorAll('[data-cart-count]');
    for (var i = 0; i < badges.length; i++) badges[i].textContent = String(cart.item_count);
    var list = document.querySelector('[data-cart-items]');
    if (!list) return;
    var empty = document.querySelector('[data-cart-empty]');
    var foot = document.querySelector('[data-cart-foot]');
    var sub = document.querySelector('[data-cart-subtotal]');
    if (sub) sub.textContent = money(cart.total_price);
    if (empty) empty.style.display = cart.items.length ? 'none' : 'block';
    if (foot) foot.style.display = cart.items.length ? '' : 'none';
    var html = '';
    cart.items.forEach(function (it) {
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
      html += '<div class="sfs-cartdrawer__item">' +
        '<div class="sfs-cartdrawer__thumb">' + (img ? '<img src="' + img + '" alt="">' : '') + '</div>' +
        '<div class="sfs-cartdrawer__info">' +
          '<p class="sfs-cartdrawer__name"><a href="' + it.url + '">' + it.product_title + '</a></p>' +
          '<p class="sfs-cartdrawer__each">' + money(it.final_price) + ' each</p>' +
          '<div class="sfs-cartdrawer__qtyrow">' +
            '<span class="sfs-cartdrawer__qty">' +
              '<button type="button" data-cart-qty="dec" data-key="' + it.key + '" aria-label="Decrease">&minus;</button>' +
              '<span>' + it.quantity + '</span>' +
              '<button type="button" data-cart-qty="inc" data-key="' + it.key + '" aria-label="Increase">+</button>' +
            '</span>' +
            '<button type="button" class="sfs-cartdrawer__remove" data-cart-remove data-key="' + it.key + '">Remove</button>' +
          '</div>' +
        '</div>' +
        '<p class="sfs-cartdrawer__line">' + money(it.final_line_price) + '</p>' +
      '</div>';
    });
    list.innerHTML = html;
  }

  function refreshShopifyCart(openAfter) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { paintShopifyCart(cart); if (openAfter) setDrawer(true); })
      .catch(function () { if (openAfter) setDrawer(true); });
  }

  function shopifyAdd(form) {
    var btn = form.querySelector('[data-add-cart]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refreshShopifyCart(true); })
      .catch(function () {})
      .then(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
  }

  function shopifyChange(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(paintShopifyCart)
      .catch(function () {});
  }

  function setDrawer(open) {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    document.body.style.overflow = open ? 'hidden' : '';
  }

  /* content renders after this script loads, so poll briefly until it exists */
  (function sync(tries) {
    if (document.querySelector('[data-cart-count]')) return renderCart();
    if (tries > 0) setTimeout(function () { sync(tries - 1); }, 250);
  })(40);

  /* hero video autoplay + scroll reveals, once content exists */
  (function initFx(tries) {
    if (!document.querySelector('.sfs-footer')) {
      if (tries > 0) setTimeout(function () { initFx(tries - 1); }, 250);
      return;
    }
    var v = document.querySelector('[data-hero-video]');
    if (v) {
      v.muted = true; v.loop = true; v.playsInline = true; v.autoplay = true;
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    }
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;
    var sels = ['.sfs-range__tile', '.sfs-collection__grid .sfs-card', '.sfs-related__grid .sfs-card',
      '.sfs-process__step', '.sfs-plan', '.sfs-flagship__media', '.sfs-flagship__row > *',
      '.sfs-craft__grid > *', '.sfs-mediawall__grid > *', '.sfs-showroom__grid > *',
      '.sfs-quote__inner', '.sfs-faq__grid > *', '.sfs-compare', '.sfs-contact__grid > *'];
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    var els = document.querySelectorAll(sels.join(','));
    var idx = 0;
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.getBoundingClientRect().top > window.innerHeight * 0.92) {
        el.classList.add('sfs-reveal');
        el.style.transitionDelay = ((idx % 3) * 90) + 'ms';
        io.observe(el);
        idx++;
      }
    }
  })(40);

  /* before/after compare slider */
  document.addEventListener('input', function (e) {
    var r = e.target.closest('[data-compare-range]');
    if (!r) return;
    var c = r.closest('[data-compare]');
    if (c) c.style.setProperty('--pos', r.value + '%');
  });

  window.addEventListener('resize', function () {
    if (window.innerWidth > 960) {
      var h = document.querySelector('.sfs-header.is-open');
      if (h) { h.classList.remove('is-open'); document.body.style.overflow = ''; }
    }
  });

  document.addEventListener('click', function (e) {
    var t;

    /* mobile nav */
    if ((t = e.target.closest('[data-nav-toggle]'))) {
      var header = t.closest('.sfs-header');
      if (header) {
        var open = !header.classList.contains('is-open');
        header.classList.toggle('is-open', open);
        t.setAttribute('aria-expanded', open ? 'true' : 'false');
        document.body.style.overflow = open ? 'hidden' : '';
      }
      return;
    }

    /* close the mobile menu after tapping a link inside it */
    if (e.target.closest('.sfs-header.is-open .sfs-header__nav a')) {
      var openHeader = document.querySelector('.sfs-header.is-open');
      if (openHeader) {
        openHeader.classList.remove('is-open');
        var tog = openHeader.querySelector('[data-nav-toggle]');
        if (tog) tog.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      }
    }

    /* nav dropdown (shop by fuel / range) */
    if ((t = e.target.closest('[data-nav-drop]'))) {
      e.preventDefault();
      var item = t.closest('[data-nav-item]');
      if (item) {
        var isOpen = !item.classList.contains('is-open');
        item.classList.toggle('is-open', isOpen);
        t.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      }
      return;
    }

    /* image carousel */
    if ((t = e.target.closest('[data-carousel-nav]'))) {
      var car = t.closest('[data-carousel]');
      var track = car.querySelector('[data-carousel-track]');
      var w = track.clientWidth;
      track.scrollTo({ left: track.scrollLeft + (t.getAttribute('data-carousel-nav') === 'next' ? w : -w), behavior: 'smooth' });
      return;
    }
    if ((t = e.target.closest('[data-carousel-dot]'))) {
      var car2 = t.closest('[data-carousel]');
      var track2 = car2.querySelector('[data-carousel-track]');
      track2.scrollTo({ left: track2.clientWidth * parseInt(t.getAttribute('data-carousel-dot'), 10), behavior: 'smooth' });
      return;
    }

    /* collection facets: fuel type and range together */
    if ((t = e.target.closest('[data-facet]'))) {
      window.__sfsApplyFacets(t.closest('.sfs-collection'), t.getAttribute('data-facet'), t.getAttribute('data-facet-value'));
      return;
    }
    if ((t = e.target.closest('[data-facet-clear]'))) {
      var facetSection = t.closest('.sfs-collection');
      if (facetSection) {
        var facetBtns = facetSection.querySelectorAll('[data-facet]');
        var facetGroups = {};
        for (var fb = 0; fb < facetBtns.length; fb++) facetGroups[facetBtns[fb].getAttribute('data-facet')] = true;
        for (var gname in facetGroups) {
          if (facetGroups.hasOwnProperty(gname)) window.__sfsApplyFacets(facetSection, gname, 'all');
        }
      }
      return;
    }

    /* open / close cart drawer */
    if ((t = e.target.closest('[data-cart-open]'))) { e.preventDefault(); setDrawer(true); return; }
    if (e.target.closest('[data-cart-close]')) { setDrawer(false); return; }

    /* add to cart: read the product from surrounding markup */
    if ((t = e.target.closest('[data-add-cart]'))) {
      if (SHOPIFY) return;
      var card = t.closest('.sfs-card');
      var name, price, img, qty = 1;
      if (card) {
        name = card.querySelector('.sfs-card__title').textContent.trim();
        price = parsePrice(card.querySelector('.sfs-card__price').textContent);
        img = card.querySelector('.sfs-card__img').src;
      } else {
        var titleEl = document.querySelector('.sfs-product__title');
        var priceEl = document.querySelector('.sfs-product__price');
        var imgEl = document.querySelector('.sfs-product__mainimg');
        var qtyInput = document.querySelector('[data-qty-input]');
        if (!titleEl || !priceEl) return;
        name = titleEl.textContent.trim();
        price = parsePrice(priceEl.firstChild ? priceEl.firstChild.textContent : priceEl.textContent);
        img = imgEl ? imgEl.src : '';
        qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      }
      addItem(name, price, img, qty);
      setDrawer(true);
      return;
    }

    /* cart drawer quantity + remove */
    if ((t = e.target.closest('[data-cart-qty]'))) {
      var step = t.getAttribute('data-cart-qty') === 'inc' ? 1 : -1;
      if (SHOPIFY) {
        var row = t.closest('.sfs-cartdrawer__item');
        var now = parseInt(row.querySelector('.sfs-cartdrawer__qty span').textContent, 10) || 1;
        shopifyChange(t.getAttribute('data-key'), Math.max(0, now + step));
      } else {
        changeQty(t.getAttribute('data-name'), step);
      }
      return;
    }
    if ((t = e.target.closest('[data-cart-remove]'))) {
      if (SHOPIFY) shopifyChange(t.getAttribute('data-key'), 0);
      else removeItem(t.getAttribute('data-name'));
      return;
    }

    /* collection filters */
    if ((t = e.target.closest('[data-filter]'))) {
      var section = t.closest('.sfs-collection');
      var value = t.getAttribute('data-filter');
      var buttons = section.querySelectorAll('[data-filter]');
      for (var i = 0; i < buttons.length; i++) buttons[i].classList.toggle('is-active', buttons[i] === t);
      var cards = section.querySelectorAll('[data-category]');
      var shown = 0;
      for (var j = 0; j < cards.length; j++) {
        var show = value === 'all' || cards[j].getAttribute('data-category') === value;
        cards[j].style.display = show ? '' : 'none';
        if (show) shown++;
      }
      var count = section.querySelector('[data-result-count]');
      if (count) {
        var noun = (count.getAttribute('data-count-noun') || 'fireplace|fireplaces').split('|');
        count.textContent = shown + ' ' + (shown === 1 ? noun[0] : noun[1]);
      }
      return;
    }

    /* fuel switcher */
    if ((t = e.target.closest('[data-fuel]'))) {
      var fuelSec = t.closest('.sfs-fuel');
      var key = t.getAttribute('data-fuel');
      var groups = ['[data-fuel]', '[data-fuel-pane]', '[data-fuel-img]'];
      for (var g = 0; g < groups.length; g++) {
        var attr = groups[g].replace(/[\[\]]/g, '');
        var nodes = fuelSec.querySelectorAll(groups[g]);
        for (var n = 0; n < nodes.length; n++) {
          nodes[n].classList.toggle('is-active', nodes[n].getAttribute(attr) === key);
        }
      }
      return;
    }

    /* product gallery thumbs */
    if ((t = e.target.closest('[data-thumb]'))) {
      var gallery = t.closest('.sfs-product__gallery');
      var main = gallery.querySelector('.sfs-product__mainimg');
      var thumbImg = t.querySelector('img');
      if (main && thumbImg) { main.src = thumbImg.getAttribute('data-full') || thumbImg.src; main.alt = thumbImg.alt; }
      var thumbs = gallery.querySelectorAll('[data-thumb]');
      for (var k = 0; k < thumbs.length; k++) thumbs[k].classList.toggle('is-active', thumbs[k] === t);
      return;
    }

    /* PDP quantity stepper */
    if ((t = e.target.closest('[data-qty]'))) {
      var input = t.parentElement.querySelector('[data-qty-input]');
      if (!input) return;
      var v = Math.max(1, parseInt(input.value, 10) || 1) + (t.getAttribute('data-qty') === 'inc' ? 1 : -1);
      input.value = String(Math.max(1, v));
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setDrawer(false);
  });

  /* product forms: add through the drawer, never redirect to /cart */
  document.addEventListener('submit', function (e) {
    var pform = e.target.closest('form[action*="/cart/add"]');
    if (!pform || !SHOPIFY) return;
    e.preventDefault();
    shopifyAdd(pform);
  });
})();

/* ---- facets, carousel dots: added with the 2026 revision ---- */
(function () {
  function cardMatches(card, group, value) {
    var tags = card.getAttribute('data-tags');
    if (tags) {
      var list = (',' + tags.toLowerCase().replace(/\s*,\s*/g, ',') + ',');
      if (list.indexOf(',' + value + ',') !== -1) return true;
    }
    var attr = card.getAttribute(group === 'range' ? 'data-category' : 'data-' + group);
    if (attr && attr === value) return true;
    return card.getAttribute('data-category') === value;
  }

  function applyFacets(section, group, value) {
    if (!section) return;
    if (group) {
      var opts = section.querySelectorAll('[data-facet="' + group + '"]');
      for (var i = 0; i < opts.length; i++) {
        opts[i].classList.toggle('is-active', opts[i].getAttribute('data-facet-value') === value);
      }
    }
    var active = {};
    var all = section.querySelectorAll('[data-facet].is-active');
    for (var j = 0; j < all.length; j++) active[all[j].getAttribute('data-facet')] = all[j].getAttribute('data-facet-value');
    var cards = section.querySelectorAll('[data-category]');
    var shown = 0;
    for (var k = 0; k < cards.length; k++) {
      var show = true;
      for (var g in active) {
        if (!active.hasOwnProperty(g) || active[g] === 'all') continue;
        if (!cardMatches(cards[k], g, active[g])) { show = false; break; }
      }
      cards[k].style.display = show ? '' : 'none';
      if (show) shown++;
    }
    var count = section.querySelector('[data-result-count]');
    if (count) {
      var noun = (count.getAttribute('data-count-noun') || 'fireplace|fireplaces').split('|');
      count.textContent = shown + ' ' + (shown === 1 ? noun[0] : noun[1]);
    }
    var empty = section.querySelector('[data-facet-empty]');
    if (empty) empty.classList.toggle('is-shown', shown === 0);
  }
  window.__sfsApplyFacets = applyFacets;

  document.addEventListener('scroll', function (e) {
    var track = e.target.closest ? e.target.closest('[data-carousel-track]') : null;
    if (!track) return;
    var car = track.closest('[data-carousel]');
    var idx = Math.round(track.scrollLeft / track.clientWidth);
    var dots = car.querySelectorAll('[data-carousel-dot]');
    for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('is-active', i === idx);
  }, true);
})();
